// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This replaces BaseCustomer class with a factory function that uses BaseApiServiceFactory

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";

export interface IBaseCustomer extends IBaseApiService {
	namespaceUrl: string;
}

export function createBaseCustomer(): IBaseCustomer {
	const baseApi = createBaseApiService();

	return {
		...baseApi,
		get namespaceUrl(): string {
			return baseApi.getBaseUrl().concat("/customer");
		},
	};
}
